<template>
    <SearchElastic
        ref="search"
        :filters="{ university_id: universityId }"
        :search-context="['courses']"
        :placeholder="$t('search:search_course')"
        :empty-results="$t('common:search.noResults')"
        truncate
    />
</template>

<script lang="ts">
import type { VNode } from 'vue';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CourseSearch',
    props: {
        /**
         * University ID that courses should be searched in
         */
        universityId: {
            type: Number,
            required: true,
        },
    },
    methods: {
        focusInput() {
            const selectElement = this.$refs.search as VNode & { focusInput: () => void };
            selectElement.focusInput();
        },
    },
});
</script>
